import { LoadingOutlined } from "@ant-design/icons";
import { Button, Form, Modal, Select, Spin } from "antd";
import React, { useEffect, useState } from "react";
import {
  openNotificationError,
  openNotificationSuccess,
} from "../../../helpers/NotificationHelpers";
import { GetUserRoleApi } from "../../../api/user-role/GetUserRoleApi";
import EditPositionUserRoleApi from "../../../api/positions/EditPositionUserRoleApi";

const { Option } = Select;

function EditPositionModal(props) {
  const [submit, setSubmit] = useState(false);
  const [roles, setRoles] = useState([]);
  const [valuesChanged, setValuesChanged] = useState(false);
  const [form] = Form.useForm();

  useEffect(() => {
    if (props.visible) {
      getRole();
    }
  }, [props.visible]);

  function handleCancel() {
    props.handleCancel();
    form.resetFields();
  }

  async function onFinish(values) {
    setSubmit(true);

    const apiResponse = await EditPositionUserRoleApi(
      props.position?.id,
      values.userRoleId
    );

    if (apiResponse.error) {
      openNotificationError("bottomRight", apiResponse.message);
    } else if (apiResponse.success) {
      openNotificationSuccess("bottomRight", "User role changed successfully");
      props.handleOk();
    } else {
      openNotificationError(
        "bottomRight",
        "Couldn't edit user role try again later."
      );
    }
    setSubmit(false);
    setValuesChanged(false);
    props.handleCancel();
  }

  async function getRole() {
    const apiResponse = await GetUserRoleApi();
    if (apiResponse.success) {
      setRoles(apiResponse.data);
      form.setFields([
        {
          name: "userRoleId",
          value: props.position?.userRole?.id,
        },
      ]);
    }
  }

  return (
    <Modal
      title="Edit user role"
      visible={props.visible}
      onOk={props.handleOk}
      onCancel={props.handleCancel}
      footer={null}
      destroyOnClose={true}
    >
      <Form
        name="editPosition"
        onFinish={onFinish}
        autoComplete="off"
        layout="vertical"
        requiredMark={false}
        onValuesChange={() => {
          setValuesChanged(true);
        }}
        form={form}
      >
        <Form.Item label="Role" name="userRoleId">
          <Select
            placeholder="Select Role"
            showSearch
            optionFilterProp="children"
            filterOption={(input, option) =>
              option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
            }
            filterSort={(optionA, optionB) =>
              optionA.children
                .toLowerCase()
                .localeCompare(optionB.children.toLowerCase())
            }
          >
            {roles?.map((typ) => {
              return (
                <Option key={typ.id} value={typ.id}>
                  {typ.name}
                </Option>
              );
            })}
          </Select>
        </Form.Item>

        <Form.Item style={{ marginBottom: 0 }}>
          <div className=" flex justify-end">
            <Button className="mr-3 w-28" onClick={() => handleCancel()}>
              Cancel
            </Button>
            <Button
              className="btn w-28"
              type="primary"
              htmlType={submit && "submit"}
              disabled={submit || !valuesChanged}
            >
              {submit ? (
                <Spin
                  size="small"
                  indicator={<LoadingOutlined style={{ color: "#fff" }} spin />}
                />
              ) : (
                "Save"
              )}
            </Button>
          </div>
        </Form.Item>
      </Form>
    </Modal>
  );
}

export default EditPositionModal;
